/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogStatus from 'layout/dialog/DialogStatus';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';
import useAutofill from '../../redux/features/autofill/useAutofill';
import Backdrop from '../backdrop/Backdrop';

export default function UnitaryEffectWarningDialog({ procedureId }) {
  const { t } = useTranslation();

  const {
    updateAutofillDialogState,
    updateConfirmAutofillDialogState,
    updateUnitaryEffectWarningDialogState,
    unitaryEffectWarningDialogState,
  } = useAutofill(procedureId);

  const handleQuit = () => {
    updateAutofillDialogState({ open: false });
    updateConfirmAutofillDialogState({ open: false });
    updateUnitaryEffectWarningDialogState({ open: false });
  };

  return (
    <Dialog data-testid="autofill-dialog" maxWidth="md" open={unitaryEffectWarningDialogState.open}>
      <DialogTitle>
        <DialogStatus variant="error" />
        <Typography component="span" variant="h2" gutterBottom>
          {t('submission.epvl.unitary.effect.dialog.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {t('submission.epvl.unitary.effect.dialog.description')}

        {unitaryEffectWarningDialogState.loading && <Backdrop blocking={true} />}
      </DialogContent>
      <DialogActions>
        <Button data-testid="cancelWarning" color="default" onClick={handleQuit}>
          {t('submission.epvl.unitary.effect.dialog.quit')}
        </Button>
        <Button
          data-testid="checkInformation"
          color="primary"
          type="submit"
          onClick={() => updateUnitaryEffectWarningDialogState({ open: false })}
        >
          {t('submission.epvl.unitary.effect.dialog.check.other')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
